import { useEffect, useRef, useState } from 'react';
import { getDataUTC } from '@portal-internet/core';
import { getNaturalDate } from 'utils/3catinfo/dateHelper';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Enllac from 'components/3catinfo/Enllac';
import Players from 'components/3catinfo/Players';
import clsx from 'clsx';
import styles from './destacatMedia.module.scss';

const DataPublicacio = (props) => {
    const { mostrarData, date } = props;
    return mostrarData && date ? (
        <time dateTime={getDataUTC(date)} className={styles.dataPub}>
            {getNaturalDate(date)}
        </time>
    ) : (
        <></>
    );
};

const MediaPlayer = (props) => {
    const { item, priorityImage, numColumnsRow, autoplay, type } = props;
    const { id, imatges, durada } = item || props;
    return (
        <Players
            id={id}
            tipus={type === 'video' ? 'destacat' : 'podcast'}
            imatges={imatges}
            autoplay={autoplay}
            numColumnsRow={numColumnsRow}
            priorityImage={priorityImage}
            testId={`destacat-media-${type}`}
            durada={durada}
        />
    );
};

const Avantitol = (props) => {
    const { mostraAvantitol, mostraPrograma, mostraTematica, item } = props;
    const { programa, avantitol, tematica } = item;

    return (
        <>
            {mostraPrograma && programa && <div className={styles.avantitol}>{programa}</div>}
            {mostraAvantitol && avantitol && <div className={styles.avantitol}>{avantitol}</div>}
            {mostraTematica && tematica && <div className={styles.avantitol}>{tematica}</div>}
        </>
    );
};

const DestacatMedia = (props) => {
    const {
        item,
        testId,
        estil,
        className,
        numColumnsRow = 0,
        tag = 'h3',
        tagPrincipal = 'article',
        mostraPrograma = false,
        mostraAvantitol = false,
        mostrarData = false,
        mostrarEntradeta = false,
        mostrarTitol = true,
        focusOnMount,
        marcatgeAudienciesClick
    } = props;

    const { id, titol, entradeta, slug, permatitle, dataPublicacio, tipologia } = item || props;

    const ref = useRef(null);

    const TagSeo = tag;
    let TagPrincipal = tagPrincipal;

    const { redlAuxState = {} } = item || props;
    const { isRedlId, isRedlTipologia } = redlAuxState;
    const [hasRedlParams, setHasRedlParams] = useState(false);
    const { zoomNavigator } = useViewport();
    const type = tipologia === 'DTY_VIDEO_MM' ? 'video' : 'audio';
    const route = {
        slug: slug || permatitle || titol,
        id,
        tipologia,
        type: type === 'video' ? 'web_3cat_item_video' : 'web_3cat_item_audio'
    };

    useEffect(() => {
        if (isRedlId || isRedlTipologia) {
            setHasRedlParams(true);
        }
    }, [isRedlId, isRedlTipologia]);

    useEffect(() => {
        if (focusOnMount && ref.current) {
            ref.current.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const styleCos = clsx(styles.cos, hasRedlParams && styles.hasRedlParams, zoomNavigator > 2 && styles.ambZoom);

    const stylesDestacat = clsx(
        styles.destacatMedia,
        estil && styles[estil],
        numColumnsRow > 0 && styles['col' + numColumnsRow],
        className
    );

    if (!id) return <></>;

    return (
        <TagPrincipal key={`destacat-media-${id}`} className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            <Enllac
                route={route}
                dataTestId='destacat-media-enllac'
                ref={ref}
                tabIndex='0'
                marcatgeAudienciesClick={marcatgeAudienciesClick}
                className={styles.enllac}
            >
                <div className={styleCos}>
                    <div className={styles.content}>
                        <Avantitol mostraPrograma={mostraPrograma} mostraAvantitol={mostraAvantitol} item={item || props} />
                        {mostrarTitol && (
                            <TagSeo className={styles.titol}>
                                <span data-testid='destacat-media-titol' dangerouslySetInnerHTML={{ __html: titol }}></span>
                            </TagSeo>
                        )}
                    </div>
                </div>
            </Enllac>
            <MediaPlayer {...props} type={type} />
            <div className={styles.info}>
                <DataPublicacio mostrarData={mostrarData} date={dataPublicacio} />
                {mostrarEntradeta && <p style={styles.entradeta}>{entradeta}</p>}
            </div>
        </TagPrincipal>
    );
};

export default DestacatMedia;
